export const staticOptions = {
  moduleName: 'VI_SYNC',
  childPrefix: 'CHILD_',
  parentPrefix: 'PARENT_'
}

// mutation types
export const ADD_IN_BROADCAST_LIST = 'ADD_IN_BROADCAST_LIST'
export const DEL_IN_BROADCAST_LIST = 'DEL_IN_BROADCAST_LIST'
export const INIT_STATE = 'INIT_STATE'
